var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 10,
    viewBox: "0 0 243 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 709"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1684",
    width: 242.222,
    height: 10,
    transform: "matrix(-1 0 0 1 242.222 0)",
    fill: "url(#paint0_linear_507_1334)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_507_1334",
    x1: 246.667,
    y1: 3.84613,
    x2: 68.3634,
    y2: 7.0555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA2128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA2128",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/Line.a5f616f4757ab13f8515a555ba009d01.svg";
export { ForwardRef as ReactComponent };